export default {"src":"/_next/static/media/hamburger_white.a8437886.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};